import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const MyActionsDashboard = lazy(() => import("./dashboard"));
const ErrorPage = lazy(() => import("@root/error"));

export const myActionsRoute: RouteObject[] = [
  {
    path: "/v2/actions/dashboard",
    element: <MyActionsDashboard />,
    errorElement: <ErrorPage />,
  },
];
